import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useReservation } from '../context';
import { ReservationDetail } from '../components/ReservationDetail/ReservationDetail';
import { ErrorSnackbar } from '../components/ReservationList/ErrorSnackbar';
import { ModalDelete } from '../components/ReservationList/ModalDelete';

export default function ReservationDetailPage() {
  const { id } = useParams<{ id: string }>();
  const {
    reservationData,
    isDataLoading,
    error,
    handleCloseError,
    navigateToEdit,
    openDeleteModal
  } = useReservation();

  if (!id) {
    return <Box>ID da reserva não encontrado</Box>;
  }

  if (isDataLoading) {
    return <Box>Carregando...</Box>;
  }

  if (!reservationData) {
    return <Box>Reserva não encontrada</Box>;
  }

  // Verificar se a reserva pode ser editada (ainda não aconteceu)
  const canEdit = () => {
    const now = new Date();
    const start = new Date(reservationData.startDate);
    return now < start;
  };

  // Verificar se a reserva pode ser deletada (ainda não terminou)
  const canDelete = () => {
    const now = new Date();
    const end = new Date(reservationData.endDate);
    return now < end;
  };

  const handleEdit = () => {
    if (canEdit()) {
      navigateToEdit(id);
    }
  };

  const handleDelete = () => {
    if (canDelete()) {
      openDeleteModal(reservationData);
    }
  };

  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />
      
      <Box sx={{ p: 3 }}>
        <ReservationDetail
          reservation={reservationData}
          onEdit={canEdit() ? handleEdit : undefined}
          onDelete={canDelete() ? handleDelete : undefined}
        />
      </Box>

      <ModalDelete />
    </>
  );
}